import { render, staticRenderFns } from "./Wearables.vue?vue&type=template&id=18b7279c&scoped=true&"
import script from "./Wearables.vue?vue&type=script&lang=ts&"
export * from "./Wearables.vue?vue&type=script&lang=ts&"
import style0 from "./Wearables.vue?vue&type=style&index=0&id=18b7279c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b7279c",
  null
  
)

export default component.exports